import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { CookieBanner } from "@/components/layout/CookieBanner";

export const SiteLayout = ({ children }) => {
  useI18n();
  const [forceOpen, setForceOpen] = React.useState(0);
  const handleOpenCookieSettings = () => setForceOpen((n) => n + 1);
  return (
    <div className="flex min-h-screen flex-col bg-white text-slate-900">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer onOpenCookieSettings={handleOpenCookieSettings} />
      <CookieBanner forceOpen={forceOpen} onClose={() => setForceOpen(0)} />
    </div>
  );
};

export default SiteLayout;
